import {Observable, Subject} from "rxjs";
import {HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {filter, tap} from "rxjs/operators";
import {Injectable} from "@angular/core";
import {getUrl} from "../../services/utils-service";

const minDedupThreshold = 100; // ms
const controlledHttpMethods: string[] = ['POST', 'GET'];
const whitelistedUrls: string[] = ['https://r.logr-ingest.com', '/api/v1.0/archivos', 'api/v1.0/personas/archivos', '/api/v1.0/instituciones/', 'assets/'];
const activeCalls: Map<string, { subject: Subject<unknown>, timestamp: number }> = new Map();
@Injectable()
export class DuplicateCallInterceptor implements HttpInterceptor {
    constructor() {
    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const urlWithoutParams = getUrl(req);
        const currentTime = Date.now();
        if (urlWithoutParams == null) {
            return next.handle(req); // No dedup
        }
        if (whitelistedUrls.some((whitelistedUrl) => urlWithoutParams.includes(whitelistedUrl))) {
            return next.handle(req); // No dedup
        }
        if (!controlledHttpMethods.includes(req.method)) {
            return next.handle(req); // No dedup
        }
        if (activeCalls.has(urlWithoutParams)) {
            const {timestamp, subject} = activeCalls.get(urlWithoutParams)!;
            let elapsed = currentTime - timestamp;
            if (elapsed < minDedupThreshold) {
                console.log(`#dedup -> ${urlWithoutParams} elapsed:${elapsed}ms, threshold:${minDedupThreshold}ms`);
                return subject.asObservable() as Observable<HttpEvent<unknown>>;
            } else {
                activeCalls.delete(urlWithoutParams);
            }
        }
        const subject = new Subject<unknown>();
        activeCalls.set(urlWithoutParams, {subject, timestamp: currentTime});
        return next.handle(req).pipe(
            filter((res) => res.type === HttpEventType.Response),
            tap({
                next: (res): void => {
                    subject.next(res);
                    subject.complete();
                    activeCalls.delete(urlWithoutParams);
                },
                error: (err): void => {
                    subject.error(err);
                    subject.complete();
                    activeCalls.delete(urlWithoutParams);
                }
            })
        );
    }
}
